import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

const KeyValueSublabelDropdown = (props: DropdownProps<server.dto.KeyValueSublabel, number>) => {
  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    options={props.options}
    getLabel={kv => kv.value}
    getValue={kv => kv.key}
    excludeKeys={props.excludeKeys}
    config={props.config}
  />;
};

export default KeyValueSublabelDropdown;